const styles = theme => ({
  table: {
    width: '100%',
    tableLayout: 'fixed',
    borderSpacing: 0,
    borderCollapse: 'separate',
    minWidth: 800,
  },
  rootStyle: {
    width: '100%',
    maxWidth: 1280,
    backgroundColor: 'transparent',
    marginTop: 24,
    marginBottom: 30,
    height: 'auto',
    padding: 0,
    borderRadius: 16,
  },
  rootHeader: {
    maxWidth: 1280,
    height: 64,
  },
  typographyHeader: {
    fontSize: '32px',
    fontWeight: 700,
    color: '#002E47',
    fontFamily: 'Inter',
    marginTop: '40px',
    marginBottom: '24px',
    width: '100%',
    maxWidth: 1280,
    letterSpacing: '-0.64px',
  },
  tableContainer: {
    backgroundColor: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: 20,
    boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.12), 0 12px 24px -4px rgba(145, 158, 171, 0.12)',
    padding: 24,
    overflow: 'clip',
    '@media (max-width: 600px)': {
      overflow: 'auto',
      padding: 16,
    },
  },
  stickyHead: {
    position: 'sticky',
    top: 50,
    zIndex: 2,
    backgroundColor: '#fff',
    '& th, & td': {
      backgroundColor: '#fff',
    },
    '@media (max-width: 600px)': {
      position: 'static',
      boxShadow: 'none',
    },
  },
  planHeaderCell: {
    backgroundColor: '#fff',
    color: '#0B1D2E',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '36px',
    letterSpacing: '-0.48px',
    width: '15%',
    borderBottom: 'none',
    padding: '16px 8px 4px',
  },
  planHeaderCellWide: {
    backgroundColor: '#fff',
    width: '40%',
    borderBottom: 'none',
    padding: '16px 16px 4px',
  },
  buttonCellWide: {
    width: '40%',
    backgroundColor: '#fff',
    borderBottom: 'none',
  },
  upgradeButtonStyle: {
    backgroundColor: '#015FFB',
    color: '#fff',
    borderRadius: 24,
    textTransform: 'none',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '13px',
    padding: '8px 16px',
    minWidth: 100,
    '&:hover': {
      backgroundColor: '#0150D8',
    },
    '&.Mui-disabled': {
      backgroundColor: '#E5E7EB',
      color: '#9CA3AF',
    },
  },
  customButtonStyle: {
    borderColor: '#002E47',
    color: '#002E47',
    borderRadius: 24,
    textTransform: 'none',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '13px',
    padding: '8px 16px',
    minWidth: 100,
    '&:hover': {
      borderColor: '#002E47',
      backgroundColor: 'rgba(0, 46, 71, 0.04)',
    },
  },
})

export default styles
